module.exports = __webpack_public_path__ + "static/img/home_fn_content_08.da5b0d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/home_fn_content_08.png
// module id = OAvn
// module chunks = 34